import { useEffect, useMemo, useState } from "react"
import EmployeInfo from "../../../components/Employeedashboard/EmployeInfo";
import WorklogInfo from "../../../components/Employeedashboard/WorklogInfo";
import EmployeePerformance from "../../../components/Employeedashboard/EmployeePerformance";
import WorklogCalender from "../../../components/Dashboard/WorklogCalendar/WorklogCalendar";
import TasksSummary from "../../../components/Employeedashboard/TasksSummary";
import ProjectPerformance from "../../../components/Employeedashboard/ProjectPerformance";
import RegularityPanel from "../../../components/Employeedashboard/RegularityPanel";
import TimesheetInfo from "../../../components/Employeedashboard/TimesheetInfo";
import CelebrationWidget from "../../../components/Employeedashboard/CelebrationWidget";
import QuickActions from "../../../components/Employeedashboard/QuickActions";
import AttendanceTracker from "../../../components/Employeedashboard/AttendanceTracker";
import LeadEmpStatus from "../../../components/LeadDashboard/LeadEmpStatus";
import TechWiseTeamCount from "../../../components/LeadDashboard/TechWiseTeamCount";

export const useEmpployeeDashboard = ({ isLeadDashboard }) => {
    const [rowHeight, setRowHeight] = useState(25);
    const [layouts, setLayouts] = useState({});

    const employeewidgets = [
        { name: "EmployeInfo", compo: <EmployeInfo />, x: 0, y: 0, width: 10, height: 7 },
        { name: "WorklogInfo", compo: <WorklogInfo />, x: 10, y: 0, width: 18, height: 7 },
        { name: "EmployeePerformance", compo: <EmployeePerformance />, x: 28, y: 7, width: 8, height: 7 },
        { name: "WorklogCalender", compo: <WorklogCalender />, x: 36, y: 0, width: 12, height: 10 },
        { name: "TasksSummary", compo: <TasksSummary />, x: 26, y: 10, width: 10, height: 5 },
        { name: "ProjectPerformance", compo: <ProjectPerformance />, x: 0, y: 7, width: 15, height: 9 },
        { name: "RegularityPanel", compo: <RegularityPanel />, x: 15, y: 7, width: 11, height: 5 },
        { name: "TimesheetInfo", compo: <TimesheetInfo />, x: 15, y: 13, width: 18, height: 4 },
        { name: "CelebrationWidget", compo: <CelebrationWidget />, x: 36, y: 14, width: 12, height: 6 },
        { name: "QuickActions", compo: <QuickActions />, x: 33, y: 14, width: 3, height: 4 },
        // { name: "AttendanceTracker", compo: <AttendanceTracker />, x: 0, y: 18, width: 50, height: 2 },
    ]

    const leadWidgets = [
        { name: "EmployeeInfo", compo: <EmployeInfo />, x: 0, y: 0, width: 10, height: 9 },
        { name: "EmployeeStatus", compo: <LeadEmpStatus />, x: 10, y: 0, width: 38, height: 4, hideCard: true },
        { name: "EmployeeTechCount", compo: <TechWiseTeamCount />, x: 10, y: 4, width: 38, height: 5, hideCard: true},
    ]

    const widgets = isLeadDashboard ? leadWidgets : employeewidgets;

    useEffect(() => {
        // handle the row height based on screen height
        function updateRowHeight() {
            const totalRows = 20;
            const gridHeight = window.innerHeight * 0.8;
            setRowHeight(gridHeight / totalRows);
        }
        updateRowHeight();
        window.addEventListener('resize', updateRowHeight);
        return () => window.removeEventListener('resize', updateRowHeight);
    }, []);

    useEffect(() => {
        const layoutArr = widgets.map((widget) => ({
            i: widget.name,
            x: widget.x,
            y: widget.y,
            w: widget.width,
            h: widget.height,
        }));

        setLayouts({
            lg: layoutArr,
            md: layoutArr,
            sm: layoutArr,
            xs: layoutArr,
        });
    }, []);

    const responsiveProps = {
        className: 'layout',
        breakpoints: { lg: 1200, md: 800, sm: 668, xs: 420 },
        cols: { lg: 48, md: 48, sm: 24, xs: 6 },
        isResizable: false,
        isDraggable: false,
        compactType: 'vertical',
        rowHeight: rowHeight,
        layouts: layouts,
    };

    return useMemo(() => ({
        responsiveProps, layouts,widgets
    }), [responsiveProps, layouts,widgets])
}